<template>
  <v-container fill-height grid-list-md>
    <v-layout
      justify-center
      align-center
      wrap
    >
      <v-flex xs12 sm6 v-if="!!_allowBB">
        <v-card class="price-tile">
          <v-card-title>
            <h3 class="headline mb-0">Прайс-лист</h3>
          </v-card-title>
          <v-card-text>
            <form>
              <v-checkbox
                v-model="pricelist.rezerv"
                label="Резерв"
                color="red"
                class="mt-0"
                hide-details
              />
              <v-checkbox
                v-model="pricelist.tranzit"
                label="Транзит"
                color="blue"
                class="mt-0"
                hide-details
              />
              <v-checkbox
                v-model="pricelist.priemka"
                label="Приемка"
                color="purple"
                class="mt-0"
                hide-details
              />
              <v-checkbox
                v-model="pricelist.recommendedOnly"
                label="Только рекомендованные ГР"
                color="accent"
                class="mt-0"
                hide-details
              />
              <v-text-field
                prepend-icon="mdi-calculator"
                v-model="pricelist.formula"
                class="mt-5"
                prefix="="
                name="formula"
                label="Формула"
                id="formula"
                autocomplete="formula"
                type="text"
                hint="Формула для цены(x - цена закупки). Например:x+x/100*2"
                required/>
            </form>
          </v-card-text>
          <v-card-actions absolute>
            <v-btn
              block
              large
              color="primary"
              dark
              @click="downloadPrice"
              :loading="pricelistLoading"
            >Скачать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 v-if="_allowB">
        <v-card class="price-tile">
          <v-card-title>
            <h3 class="headline mb-0">Прайс-лист</h3>
          </v-card-title>
          <v-card-text>
            <form>
              <v-checkbox
                v-model="pricelistBn.recommendedOnly"
                label="Только рекомендованные ГР"
                color="accent"
                class="mt-0"
                hide-details
              />
              <v-checkbox
                  v-model="pricelistBn.rezerv"
                  label="Резерв"
                  color="red"
                  class="mt-0"
                  hide-details
              />
            </form>
            <v-text-field
              prepend-icon="mdi-calculator"
              v-model="pricelistBn.formula"
              class="mt-5"
              prefix="="
              name="formula_bn"
              label="Формула"
              id="formula_bn"
              autocomplete="formula_bn"
              type="text"
              hint="Формула для цены(x - цена закупки). Например:x+x/100*2"
              required/>
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              large
              color="primary"
              dark
              @click="downloadPriceBn"
              :loading="pricelistBnLoading"
            >
              Скачать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <!--<v-container fill-height grid-list-md>-->

  <!--</v-container>-->
</template>

<script>
import httpService from '@/api/httpService'
import FileSaver from 'file-saver'
import { format } from 'date-fns'
import { mapGetters } from 'vuex'

export default {
  name: 'pricelist',
  data () {
    return {
      pricelistLoading: false,
      pricelistBnLoading: false,
      pricelist: {
        rezerv: true,
        tranzit: true,
        priemka: true,
        recommendedOnly: false,
        formula: 'x'
      },
      pricelistBn: {
        recommendedOnly: false,
        rezerv: true,
        formula: 'x'
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      _allowB: 'allowB',
      _allowBB: 'allowBB'
    })
  },
  methods: {
    async downloadPrice () {
      this.pricelistLoading = true
      let response = await httpService({
        url: `price/download`,
        method: 'POST',
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        data: this.pricelist
      })
      FileSaver.saveAs(response.data, `price_${format(new Date(), 'YYYY-MM-DD')}.xls`)
      this.pricelistLoading = false
    },
    async downloadPriceBn () {
      this.pricelistBnLoading = true
      let response = await httpService({
        url: `price/download_buh`,
        method: 'POST',
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        data: this.pricelistBn
      })
      FileSaver.saveAs(response.data, `price_bn_${format(new Date(), 'YYYY-MM-DD')}.xls`)
      this.pricelistBnLoading = false
    }
  }
}
</script>

<style scoped>
  .price-tile {
    height: 380px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
  }
</style>
